const Scale = {
  Five: 5,
  Six: 6,
  Ten: 10,
  Eleven: 11,
};

export default Scale;
